import { VelavuRequestError } from "../error/error";
export var VelavuRuleCategory;
(function (VelavuRuleCategory) {
    VelavuRuleCategory["User"] = "USER";
    VelavuRuleCategory["System"] = "SYSTEM";
    VelavuRuleCategory["Managed"] = "MANAGED";
})(VelavuRuleCategory || (VelavuRuleCategory = {}));
export var VelavuRuleValidationErrorType;
(function (VelavuRuleValidationErrorType) {
    VelavuRuleValidationErrorType["InvalidCondition"] = "ERR_INVALID_COND";
    VelavuRuleValidationErrorType["InvalidAction"] = "ERR_INVALID_ACTION";
    VelavuRuleValidationErrorType["InvalidPriority"] = "ERR_INVALID_PRIO";
})(VelavuRuleValidationErrorType || (VelavuRuleValidationErrorType = {}));
/// An error thrown when a rule validation fails
export class VelavuRuleValidationError extends VelavuRequestError {
    reason;
    constructor(originalError) {
        super(originalError.statusCode, originalError.raw);
        this.name = "VelavuRuleValidationError";
        this.reason = originalError.reason;
    }
}
//# sourceMappingURL=rule.js.map